const removeTypenameFields = (val) =>
  JSON.parse(JSON.stringify(val), (key, value) =>
    key === '__typename' ? undefined : value
  )

export function GraphQLRemoveTypename({
  data,
  children
}: {
  readonly data: any
  readonly children: (props: any) => any
}) {
  return children({
    data: removeTypenameFields(data)
  })
}
